import { type TChatbotNode } from './node.type'
import { type Edge } from '@xyflow/react'
import { ELocale } from 'src/types/locales'

export const DEFAULT_NODE_TYPE = 'chatbotMessage'
export const DEFAULT_EDGE_TYPE = 'custom'
export const DEFAULT_LOCALE = ELocale.FR

export const INITIAL_NODE_POSITION = { x: 250, y: 100 }
export const NODE_VERTICAL_SPACING = 280
export const NODE_HORIZONTAL_OFFSET = 320 // Horizontal spacing for conditional branches (node width + margin)
export const COLLISION_THRESHOLD = 280 // Distance threshold for collision detection (node width)
export const NODE_SPACING = 320 // Spacing between nodes when collision is detected (node width + margin)

export const MEDIA_UPLOADED_HANDLE = 'mediaUploaded'
export const MEDIA_NOT_UPLOADED_HANDLE = 'mediaNotUploaded'

export const START_NODE_ID = 'Start'
export const FIRST_EDITABLE_NODE_ID = 'node-0'

export const INITIAL_NODES: TChatbotNode[] = [
  {
    id: START_NODE_ID,
    type: DEFAULT_NODE_TYPE,
    position: INITIAL_NODE_POSITION,
    data: {
      title: '',
      messagesByLanguage: { [DEFAULT_LOCALE]: '' },
      isEditable: false,
    },
    selectable: false,
    deletable: false,
  },
  {
    id: FIRST_EDITABLE_NODE_ID,
    type: DEFAULT_NODE_TYPE,
    position: {
      x: INITIAL_NODE_POSITION.x,
      y: INITIAL_NODE_POSITION.y + NODE_VERTICAL_SPACING,
    },
    data: {
      title: '',
      messagesByLanguage: { [DEFAULT_LOCALE]: '' },
      isEditable: true,
    },
    selected: true,
  },
]

export const INITIAL_EDGES: Edge[] = [
  {
    id: 'edge-0',
    source: START_NODE_ID,
    target: FIRST_EDITABLE_NODE_ID,
    type: DEFAULT_EDGE_TYPE,
  },
]
